import { useTranslation } from 'react-i18next';
import { checkered } from '../../styles/selectStyles';
import React from 'react';
import { HandoverProtocol } from '../../models/table-models';
import dateFormat from 'dateformat';

export const DashboardProtocol = ({ item }: { item: HandoverProtocol }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'table' });
    const fields = [
        { name: 'date', format: (s: string) => dateFormat(s, 'dd.mm.yyyy HH:MM:ss') },
        { name: 'taskCategory', label: t('taskType') },
        { name: 'price', unit: '€', format: (s: string) => (Number(s) / 100).toFixed(2), label: t('justPrice') },
        { name: 'distributor' },
        { name: 'clientRepresentative' },
    ];

    const detailsField = (
        fieldName: keyof HandoverProtocol,
        index: number,
        unit?: string,
        format?: (s: string) => string,
        label?: string,
    ) => {
        const value = item[fieldName];
        const formattedValue = format && value ? format(value.toString()) : value;

        return (
            <div key={index} className={`border d-flex p-2 justify-content-between ${checkered(index)}`}>
                <div>{label ?? t(fieldName)}:</div>
                <div className=' ms-4'>
                    {formattedValue} {unit}
                </div>
            </div>
        );
    };

    return (
        <>
            <div className='w-100'>
                <div className={'align-self-center'}>
                    {fields.map(({ name, format, label }, index) =>
                        detailsField(name as keyof HandoverProtocol, index, undefined, format, label),
                    )}
                </div>
            </div>
        </>
    );
};
